import usColumnDefinitions, { TYPES } from './usColumnDefinitions';

export default ({
  groupByName,
  groupByField,
  hasSourceCurrency,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
}) => usColumnDefinitions({
  groupByName,
  groupByField,
  hasSourceCurrency,
  type: TYPES.STATE,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
});
